module.exports = __webpack_public_path__ + "img/thumbnail_AfricanCrestedPorcupine_m_albino.0b09d189.png";